import React, { useCallback, useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Helmet } from 'react-helmet';

import Text from '../../components/Text';
import ImagePicker from './ImagePicker';
import Button from '../../components/Button';
import { Article, Product, Twig } from '../../types';
import List from '../../components/List';
import { FaShareAlt } from 'react-icons/fa';
import ProductCard from '../../components/ProductCard';
import { getProductByBusiness } from '../../services/productService';
import Slider from '../../components/Slider';
import { Link } from 'react-router-dom';
import { track } from '../../services/mixpanelService';
import { ModalProps } from 'react-bootstrap';
import { getArticlesById } from '../../services/ApiService';
import Loader from '../../components/Loader';

import ArticleCard from '../../components/ArticleCard';
export interface DetailsProps extends ModalProps{
  product: Product;
  item?: any;
  onAddToCart: () => void;
}
const Details: React.FC<DetailsProps> = ({ product,
  item,
  onAddToCart,
 }) => {
  const classes = useStyles();
  const hasDiscount = product.originalPrice !== product.discountedPrice && product.discountedPrice != 0;
  // const discount = hasDiscount
  //   ? calculateDiscount(product.originalPrice, product.discountedPrice)
  //   : 0;
  const { currencyCode } = product.currency;
  const images=product.images.map((image)=>image.name);
  const variantsImage=product.variants.map((image)=>image.image);
  const [products, setProducts] = useState<Product[]>([]);
  const [selectedTab, setSelectedTab] = useState<string>(product.description != null ? "description" : "return");
  const [idOptionColor,setIdOptionColor]=useState<number>(product.options["Color"]!=undefined  ? product?.options["Color"][0].id : 0);
  const [idOptionSize,setIdOptionSize]=useState<number>(product.options["Size"]!= undefined ? product?.options["Size"][0].id : 0);
  const [imageBigBox,setImageBigBox]=useState<number>(0);
  const [fromWhere,setFromWhere]=useState<boolean>(false);
  const [articles,setArticles]=useState<Article[]>([]);
  const [loadingArticles,setLoadingArticles]=useState<boolean>(true);
  const goToLink = useCallback((link) => {
    window.open(link, "_blank") //to open new page
  }, []);
  const [selectedOptionsDet, setSelectedOptionsDet] = useState<
  Record<string, number>
>(() => {

    const ret: Record<string, number> = {};
    Object.keys(product.options).forEach((key) => {
    ret[key] = product.options[key][0].id;
    });
    return ret;
});
const handleSelectOptionDet = useCallback(
    (item:any,{ target: { name, value } },key:any)   => {          
    setSelectedOptionsDet({
      ...selectedOptionsDet,
      [name]: parseInt(value, 10),
    });
    const keyValue=key.toLowerCase();
    if(keyValue=='color'){
      setIdOptionColor(value);
      item.map((element:any,index:number)=>{
          if(element.optionValues[1].id==idOptionSize && element.optionValues[0].id==value  &&  element.image!=null){
            setImageBigBox(index);
            setFromWhere(true); 
        }
      })        
      }
    else{
      setIdOptionSize(value);
      item.map((element:any,index:number)=>{
        if(element.optionValues[1].id==value && element.optionValues[0].id==idOptionColor  &&  element.image!=null){
          setImageBigBox(index);
          setFromWhere(true); 
        }
      })
}
  },
  [selectedOptionsDet],
);

useEffect(() => {
  setLoadingArticles(true);
  (async () => {
    try {
      const articles=await getArticlesById("product_id="+product.id);
      setArticles(articles);
      setLoadingArticles(false)
    } catch (e) { }
  })();
}, []);


  useEffect(() => {
    (async () => {
      try {
        
        let tempProducts = await getProductByBusiness(product.business.id)
        setProducts(tempProducts);
        // const { twigs: response, pagination } = await getTwigsByBusinessID(
        //   business.id,
        //   1,
        //   10,
        // );
        // setTwigs(response);
        // if (currentPage >= pagination.totalPages) {
        //   setHasMore(false);
        // } else {
        //   setCurrentPage(currentPage + 1);
        // }
        // setDoInfiniteScroll(true);
        // setLoadingTwigs(false);
      } catch (e) { }
    })();
  }, [product]);


  const handleShare = useCallback(() => {
    try {
      // @ts-ignore
      if (typeof window.navigator.share === 'function') {
        // @ts-ignore
        window.navigator.share({
          text: product.description,
          url: window.location.href,
          
        });
        track("share")

      }
    } catch (e) { }
  }, [product]);

  return (


    <>
       <Helmet>
          <title>{product.name}| twigBIG | Social eCommerce Marketplace in Beauty and Fashion</title>
          <meta property="og:image" content={product.photo} />
          
      </Helmet>
    <Container fluid itemScope itemType="http://schema.org/Product">
      <Row>
        {images.length ? (
          <Col xs={12} lg={6}>
            <ImagePicker fromWhere={fromWhere} primaryImage={product.photo} variantsImage={variantsImage} selectedVariantImage={imageBigBox} images={images} itemprop='image' />
          </Col>
        ) : null}
        <Col xs={12} lg={images.length ? 6 : 12}>
          <div className={classes.rightSide}>
            <Text as="h1" fontSize="size2" bold itemprop='name'>{product.name}</Text>
            <div className={classes.priceAndActionsBox}>
              <div itemProp={hasDiscount ? 'offers' : 'null'} itemScope itemType={hasDiscount ? "http://schema.org/Offer" : ""} >
                {hasDiscount ? (
                  <Text
                    className={clsx(classes.lastPrice, 'mb-0')}
                    as="p"
                    decoration="line-through"
                    uppercase
                    bold
                  >
                    {product.originalPrice} {currencyCode}
                  </Text>
                ) : null}
                <Text itemprop="price" className={classes.currentPrice} as="span" uppercase bold>
                  {hasDiscount ? product.discountedPrice : product.originalPrice}{' '}
                </Text>
                <Text className={classes.currentPrice} as="span" itemprop="priceCurrency" uppercase bold>{currencyCode}</Text>
              </div>
              <div className={classes.actionsBox}>
                {
                  product.is_verified ?
                    product.affiliate == "EXTERNAL" || product.affiliate == "INTERNAL" ?
                      <Button
                        className={clsx('mr-2', classes.actionBtn)}
                        onClick={e => goToLink(product.affiliate == "EXTERNAL" ? product.affiliate_link : product.original_url)}
                        color="primary"
                        rounded
                      >
                        <Text color='white' as="span" bold capitalized>
                          Buy On {product.business.name}
                        </Text>
                      </Button>
                      :
                      <Button
                        className={clsx('mr-2', classes.actionBtn)}
                        onClick={onAddToCart}
                        color="primary"
                        rounded
                      >
                        <Text color='white' as="span" bold capitalized>
                          Add To Cart
                        </Text>
                      </Button>
                    : null
                }
                {/* <Button
                  className={clsx('mr-2', classes.actionBtn)}
                  onClick={onAddToCart}
                  color="secondary"
                  rounded
                >
                  <Text className="mb-0" capitalized bold color='primary'>
                    Add to cart
                  </Text>
                </Button> */}


                <Button
                  className={clsx('mr-2', classes.shareBtn)}
                  onClick={handleShare}
                  color="primary"
                  rounded
                >
                  <FaShareAlt className={classes.shareIcon} />

                </Button>
                {/* <Button className={clsx(classes.actionBtn)} rounded>
                  <Text className="mb-0" color="white" capitalized>
                    Buy now
                  </Text>
                </Button> */}
              </div>
            </div>
            <div className={classes.descriptionBox}>
              <Text as="p" itemprop="description">{product.description}</Text>
            </div>
            <div>
              {Object.keys(product.options).map((key) => (
                <div {...{ "itemScope": key.toLowerCase() != 'color' ? true : false }} itemProp={key.toLowerCase() != 'color' ? "additionalProperty" : ""} itemType={key.toLowerCase() != 'color' ? "http://schema.org/PropertyValue" : ""} key={key} className={classes.productOption}>
                  <Text itemprop={key.toLowerCase() != 'color' ? "name" : ""} className={classes.productOptionName} capitalized bold>
                    {key}:
                  </Text>
                  
                  {product.options[key].map((value) =>(
                   
                  <div
                  
                  className={classes.optionBox}>
                    <div
                      className={clsx(classes.option, {
                        [classes.optionLabelSelected]:
                          selectedOptionsDet[key] === value.id,
                      })}
                      key={value.id}
                    >
                      <input
                        className={classes.optionInput}
                        id={`optionDet-${value.id}`}
                        type="radio"
                        value={value.id}
                        name={key}
                        checked={selectedOptionsDet[key]=== value.id}
                        onChange={e=>handleSelectOptionDet(product.variants,e,key)}
                      />
                      <label
                        className={classes.optionLabel}
                        htmlFor={`optionDet-${value.id}`}
                      >
                        {key.toLowerCase() === 'color' ? (
                          <div
                            className={classes.options}
                            style={{
                              backgroundColor: '#'+value.value,
                            }}
                          />
                        ) : (
                              <Text
                                itemprop="value"
                                key={value.id}
                                className={classes.productOptionValue}
                                as="span"
                                bold
                              >
                                {value.value}
                              </Text>
                        )}
                      </label>
                    </div>
                <div
                  id="changeImageNotFromVariants"
                  style={{display:"none"}}
                  onClick={()=>{setFromWhere(false)}}
                />
                
                </div>
              ))}
                </div>
              ))}
            </div>
            {
              product.brand ? <h5 className={classes.brandName}>{product.brand.name}</h5>
                : null
            }
            <Link to={product.business.uniqueName} className={classes.linkBusinessName}>
              <h5 className={classes.businessName}>{product.business.uniqueName}</h5>
            </Link>
          </div>
        </Col>
      </Row>
      {/* {product.description ? <Row>
        <Col xs={12}>
          <Text bold as="h4">Product Description</Text>
          <div className={classes.spreter}></div>

          <Text as="p">{product.description}</Text>
        </Col>
      </Row>
        : null
      } */}

      <Row>
        <Col xs={12}>
          <div className={classes.tabs}>
            {
              product.description != null ?
                <>
                  <div onClick={e => setSelectedTab("description")} className={classes.oneTab}>
                    <Text bold={selectedTab == 'description' ? true : false} as="h4"> Description</Text>
                    {
                      selectedTab == 'description' ?
                        <div className={classes.selectedTab}></div>
                        : null
                    }
                  </div>
                  <div className={classes.spreter}></div>
                </>
                : null
            }
            <div onClick={e => setSelectedTab("return")} className={classes.oneTab}>
              <Text bold={selectedTab == 'return' ? true : false} as="h4">Return Policy</Text>
              {
                selectedTab == 'return' ?
                  <div className={classes.selectedTab}></div>
                  : null
              }
            </div>
          </div>
        </Col>
        <Col className={classes.containtTabs} xs={12}>
          {selectedTab == 'description' ?
            <Text as="p">
              {product.description}
            </Text>
            :
            <Text as="p">
              {product.business.return_and_exchanges_policy}
            </Text>

          }
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <div className={classes.productsBox}>

            <Text as="h4" bold align="center">More from {product.business.name}</Text>
            <Slider responsive={[
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  infinite: true,
                },
              },
              {
                breakpoint: 1000,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  initialSlide: 2,
                },
              }, {
                breakpoint: 800,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  initialSlide: 1,
                },
              }]}>
              {products.map((product) => (
                <div
                  key={product.id}
                  className={classes.productSlideWrapper}
                >
                  <ProductCard
                    className={classes.productSlide}
                    product={product}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </Col>

        {loadingArticles||articles.length ? (
          <Col xs={12}>
          <div className={classes.articlesBox}>
                <Loader
                  className={classes.articlesLoader}
                  loading={loadingArticles}
                  center
                >
                  {()=>(
                    <>
                      <div className={classes.articlesHeader}>
                        <Text bold>Articles</Text>
                      </div>
                      <Slider
                        responsive={[
                          {
                            breakpoint: 1024,
                            settings: {
                              slidesToShow: 3,
                              slidesToScroll: 3,
                              infinite: true,
                            },
                          },
                          {
                            breakpoint: 1000,
                            settings: {
                              slidesToShow: 2,
                              slidesToScroll: 2,
                              initialSlide: 2,
                            },
                          }, {
                            breakpoint: 800,
                            settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              initialSlide: 1,
                            },
                          }]}>
                          {articles.map((article) => (
                            <div
                              key={article.id}
                              className={classes.articleSlideWrapper}
                            >
                              <ArticleCard
                              article={article}
                              />
                            </div>
                          ))}
                          </Slider>
                    </>
                  )}
                </Loader>
              </div>
        </Col>
        ) : null}
      </Row>
    </Container >
    </>
  );
};

const useStyles = createUseStyles({
  articlesBox:{
    marginTop: '30px',
  },
  articlesHeader:{
    display: 'flex',
    justifyContent: 'space-between',
  },
  articleSlideWrapper:{
    paddingLeft: '10px',
    paddingRight: '10px',
    minHeight: '320px',
    display: 'flex !important',
    flexDirection: 'column',
    position: 'relative'
  },
  rightSide: {
    '@media screen and (max-width: 970px)': {
      marginTop: '30px',
    },
  },
  priceAndActionsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    '@media screen and (max-width: 512px)': {
      display: 'block',
    },
  },
  lastPrice: {
    fontSize: '0.8rem',
  },
  currentPrice: {
    fontSize: '1.1rem',
  },
  actionsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '@media screen and (max-width: 512px)': {
      display: 'block',
      textAlign: 'center',
    },
  },
  actionBtn: {
    padding: '5px 20px !important',
  },
  optionLabelSelected: {
    // backgroundColor: '#eee',
    border: "1px solid #522e91",
    '&:hover': {

      border: "1px solid #522e91",
      transitionDuration:'0.5s',

    },
  },
  optionBox: {
    marginBottom: '15px',
    display: 'inline-block',
  },
  shareBtn: {
    width: '34px',
    height: '34px',
    padding: '0px !important',
  },
  shareIcon: {
    marginBottom: '3px'
  },
  options:{
    width: 20,
    height: 20,
    borderRadius: '50%',
  },
  descriptionBox: {
    fontSize: '0.9rem',
    color: '#555555',
    marginTop: '15px',
  },
  productOption: {
    '&:not(:first-child)': {
      marginTop: '5px',
    },

    '&:not(:last-child)': {
      // borderBottom: '1px solid #eee',
      padding: '10px 0',
    },
  },
  productOptionName: {
    borderBottom: '2px solid #eee',
    paddingBottom: '5px',
    marginBottom: '8px !important',
  },
  productOptionValue: {
    marginRight: '15px',
    display: 'inline-block',
  },
  productsBox: {
    marginTop: '30px',
  },
  linkBusinessName: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  businessName: {
    color: '#8D8D8D',
    fontWeight: "100",
    fontSize: '0.8rem',
    border: "1px solid #8D8D8D",
    width: "fit-content",
    borderRadius: "4px",
    padding: "6px 5px 4px",
    marginTop: "15px",
  },
  brandName: {
    color: "white",
    width: "fit-content",
    border: "1px solid #522e91",
    fontSize: '0.8rem',
    borderRadius: "4px",
    padding: "6px 5px 4px",
    marginTop: "15px",
    backgroundColor: "#522e91"
  },
  productSlideWrapper: {
    paddingLeft: '10px',
    paddingRight: '10px',
    minHeight: '400px',
    display: 'flex !important',
    flexDirection: 'column',
    position: 'relative'
  },
  productSlide: {
    flex: 1,
  },
  spreter: {
    width: "2px",
    margin: "7px 3px",
    height: "20px",
    backgroundColor: "#5d5d5d"
  },
  tabs: {
    display: 'flex',
    marginBottom: "5px"
  },
  oneTab: {
    position: "relative",
    cursor: 'pointer',
    margin: "0px 10px"
  },
  selectedTab: {
    height: "10px",
    width: "10px",
    bottom: "-5px",
    position: "absolute",
    backgroundColor: "#522e91",
    left: "calc(50% - 5px)",
    borderRadius: "50%"
  },
  containtTabs: {
    marginTop: '15px'
  },
  optionInput: {
    display: 'none',
  },
  optionLabel: {
    margin: '0',
    cursor: 'pointer',
  },
  option: {
    marginRight: '10px',
    // backgroundColor:'#f1f2f6',
    padding: '5px 15px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: 'rgb(0 0 0 / 39%) 0px 0px 2px',
    borderRadius: '30px',
    cursor: 'pointer',
    '&:hover': {
      transitionDuration:'0.5s', 
      border: "1px solid #522e91",
    },
  },
  articlesLoader:{
    minHeight: '50vh',
  },
   
});

export default Details;
